// extracted by mini-css-extract-plugin
export default {"ActionLeague":"index_ActionLeague_mBxMj","slideItem":"index_slideItem_BIFif","last":"index_last_nguWP index_slideItem_BIFif","text_wrap":"index_text_wrap_fG0ir"};